// @flow
import React, { useState, useMemo, type Node } from 'react'
import {
    HelmetWrapper,
    SecurityHelper,
} from 'sarsaparilla'

import useLayoutSize from '../hooks/useLayoutSize'

type SetState<T> = (T | (T) => T) => void
export type LayoutControl = {
    isFullView: boolean,
    isMobileApp: boolean,
    isShowAvailabilityFilters: boolean,
    setIsFullView: SetState<boolean>,
    setIsShowAvailabilityFilters: SetState<boolean>,
    isInformationRequired: boolean,
    windowSize: string,
}

const defaultLayoutControl: LayoutControl = {
    isFullView: false,
    isMobileApp: false,
    isShowAvailabilityFilters: true,
    isInformationRequired: false,
    setIsFullView: () => {},
    setIsShowAvailabilityFilters: () => {},
    windowSize: 'md'
};

export const LayoutControlContext = React.createContext<LayoutControl>(defaultLayoutControl);

type PropTypes = {
    children?: Node,
    permitName?: string,
    isInformationRequired?: boolean,
}
const DetailedAvailabilityPageLayout = ({
    children,
    permitName = '',
    isInformationRequired = false,
}: PropTypes) => {
    const [isFullView, setIsFullView] = useState<boolean>(false)
    const isMobileApp = SecurityHelper.isMobileApp();
    const [isShowAvailabilityFilters, setIsShowAvailabilityFilters] = useState<boolean>(isMobileApp)
    const windowSize = useLayoutSize();

    const layoutControl = useMemo(() => ({
        isFullView,
        isInformationRequired,
        isMobileApp,
        isShowAvailabilityFilters,
        setIsFullView,
        setIsShowAvailabilityFilters,
        windowSize,
    }), [isFullView, isInformationRequired, isMobileApp, isShowAvailabilityFilters, setIsFullView, setIsShowAvailabilityFilters, windowSize])

    return (
        <div className="per-availability-page">
            <HelmetWrapper title={`${permitName} Detailed Availability`} />
            <div className="per-availability-layout per-availability-layout-new">
                <LayoutControlContext.Provider value={layoutControl}>
                    {children}
                </LayoutControlContext.Provider>
            </div>
        </div>
    )
}

export default DetailedAvailabilityPageLayout;
